import * as React from "react";

function SvgPlanetPluto(props) {
  return (
    <svg viewBox="0 0 56.06 56.06" {...props}>
      <defs>
        <radialGradient
          id="planet-pluto_svg__d"
          cx={-2134.92}
          cy={1439.87}
          r={30.4}
          gradientTransform="matrix(.03 -.89 .91 -.16 -1240.61 -1642.75)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.77} />
        </radialGradient>
        <radialGradient
          id="planet-pluto_svg__f"
          cx={-2134.92}
          cy={1439.87}
          r={30.4}
          gradientTransform="matrix(.03 -.89 .91 -.16 -1240.61 -1642.75)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.77} stopColor="#f3f9f7" />
        </radialGradient>
        <filter
          id="planet-pluto_svg__a"
          x={2.35}
          y={-8116}
          width={33.35}
          height={32766}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <filter
          id="planet-pluto_svg__c"
          x={2.35}
          y={3.62}
          width={33.35}
          height={33.02}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <mask
          id="planet-pluto_svg__e"
          x={2.35}
          y={3.62}
          width={33.35}
          height={33.02}
          maskUnits="userSpaceOnUse"
        >
          <g
            mask="url(#planet-pluto_svg__b)"
            filter="url(#planet-pluto_svg__c)"
          >
            <path
              d="M8.86 9.55c7.07-6.79 18.37-8.11 24.29-2s.54 11.57-6.22 20c-5.56 6.9-15.1 12.67-21 6.59S1.79 16.34 8.86 9.55z"
              style={{
                mixBlendMode: "multiply",
              }}
              fill="url(#planet-pluto_svg__d)"
            />
          </g>
        </mask>
      </defs>
      <g data-name="Layer 2">
        <circle cx={28.03} cy={28.03} r={28.03} fill="#b2c3a5" />
        <path
          d="M21.26 1.08A28.09 28.09 0 001.89 18.17a6.89 6.89 0 006.52 3.24c1.87-.27 3.52-1.41 5.38-1.76s3.78.11 5.63-.22 3.77-2 3.22-3.82a7.35 7.35 0 00-1.79-2.32 5.86 5.86 0 01-.12-7.19c-1.1-1.43-.66-3.61.5-5z"
          fill="#c8dcbe"
        />
        <path
          d="M27.89 35.84a1.77 1.77 0 01-.79-1.92 7.61 7.61 0 00.24-2.21c-.13-.74-.94-1.42-1.59-1.06a4.24 4.24 0 00-2.52-5.12A4.25 4.25 0 0018 27.9c-.26.68-.34 1.42-.64 2.09a1.83 1.83 0 01-1.66 1.19 22.82 22.82 0 00-2.27 5.74 14 14 0 00-.32 5.41c.49 2.14 1.89 3.92 3.15 5.67s2.43 3.82 2.29 6c-.53-1.53 1.41-3 3-3.47a13.84 13.84 0 014.85-.07c1.62.09 3.43-.12 4.52-1.33a11.39 11.39 0 011.28-1.57 6.62 6.62 0 012-.8c2.36-.82 3.81-3.12 5.09-5.26s2.58-4.62 1.76-6.95a4.44 4.44 0 00-6.47-2A21.87 21.87 0 0030 31.8c-1.19-.07-2.66.16-3.06 1.28-.26.78 1.33 2.02.95 2.76z"
          fill="#d5e3cc"
        />
        <path
          d="M13.05 42.28c-.6-2 .2-4.19 1-6.17l.54-1.36A1.82 1.82 0 0012 32.5a9.26 9.26 0 01-3.92 1.31c-2.5.19-5.29-.71-7.28.85a28.06 28.06 0 0017 19.45A10 10 0 0016.21 47c-1.07-1.59-2.61-2.9-3.16-4.72zM28 56.06a28 28 0 0024.7-14.7 6.81 6.81 0 00-2-.84 4.46 4.46 0 00-3.64.7c-1.43 1.1-2 3.23-3.72 3.84-2.18.79-4.77-1.47-6.78-.32-1.07.61-1.57 2-2.75 2.44-.82.27-1.86 0-2.48.59a5.45 5.45 0 00-.69 1.31 3 3 0 01-2.29 1.28c-.9.1-1.81 0-2.71.1a8.1 8.1 0 00-4.51 2.3 15.92 15.92 0 00-1.71 2 28.22 28.22 0 008.58 1.3z"
          fill="#987671"
        />
        <path
          d="M5.64 20.74l.84.84.42.42a.94.94 0 00.43.16c.44.1.63-.58.19-.68A1.33 1.33 0 016.9 21l-.76-.76c-.32-.33-.82.17-.5.5zM21.6 8a.81.81 0 01.67-.15l-.21-.52c0 .08-.1.07-.18 0l.26.34v-.44l-.1.25h-.24c.35.29.85-.21.5-.5a.54.54 0 00-.66-.07c-.27.16-.2.52-.2.78a.36.36 0 00.26.31.8.8 0 001-.36.36.36 0 00-.21-.52 1.48 1.48 0 00-1.21.22c-.4.28-.04.89.32.66zM23.92 4.52v.11a.36.36 0 00.71 0v-.11a.36.36 0 00-.71 0zM23.82 8a.36.36 0 000-.71.36.36 0 000 .71zM24.92 53.23a.58.58 0 101.13-.07.32.32 0 00-.42 0z"
          fill="#c8dcbe"
        />
        <path
          d="M25.5 54a.64.64 0 01-.46-.21.67.67 0 01-.19-.52h.14a.52.52 0 00.15.4.46.46 0 00.75 0 .49.49 0 00.09-.4.24.24 0 00-.3 0l-.1-.1a.39.39 0 01.52 0 .68.68 0 01-.58.81z"
          fill="#c8dcbe"
        />
        <path
          d="M21.57 33.63a5.36 5.36 0 011.29 1.27 7.43 7.43 0 004.46 1.9 15.15 15.15 0 014.78 1.1c1.47.75 2.65 2.37 2.28 4a3.83 3.83 0 01-2 2.36 18.52 18.52 0 01-3 1.09 20.6 20.6 0 00-9.64 6.75c.9-2.09-.66-4.34-1.59-6.42a12.22 12.22 0 010-9.91 4.7 4.7 0 011.29-1.81 2.1 2.1 0 012.13-.33z"
          fill="#e2e9ff"
        />
        <path
          d="M19.77 18.63c-1.56-.5-3.21.21-4.8.63s-3.63.33-4.42-1.1.11-3.06 1.23-4.14 2.53-1.92 3.24-3.3a9.16 9.16 0 00.7-3.08 6 6 0 011-3 2.3 2.3 0 012.81-.78c-.67.52-.2 1.67.55 2.06s1.65.37 2.44.69 1.44 1.3.94 2a1.94 1.94 0 00-2.71 1A1.92 1.92 0 0022.3 12a3.15 3.15 0 001.93-.58 7.25 7.25 0 011.82-.92 1.75 1.75 0 011.86.52c.39.56.07 1.53-.62 1.56.61-.06 1 .77.74 1.33a2.48 2.48 0 01-1.42 1.1 3.14 3.14 0 00-1.5 1c-.64 1 .11 2.54-.65 3.46a2.06 2.06 0 01-2.39.29c-.79-.3-1.48-.87-2.3-1.13z"
          fill="#c8dcbe"
        />
        <path
          d="M35.84 1.06a16.13 16.13 0 011.91 6.4c.08 2.56-1.22 5.36-3.65 6.21a6.44 6.44 0 00-1.79.68c-.52.38-.8 1.21-.34 1.66l2.33 2a4.26 4.26 0 00-2.57 2 2.24 2.24 0 00.83 2.99 2.07 2.07 0 002.23-.4 3.15 3.15 0 00.93-2.16c.05-1-.13-2.25.75-2.71a1.46 1.46 0 011.81.76 3.93 3.93 0 01.27 2.13 4.67 4.67 0 00.19 2.14c.3.71 1 1.32.89 2.08s-.73 1.15-1 1.78a2.33 2.33 0 00.3 2.17 6.8 6.8 0 001.63 1.58c.87.67 2.05 1.37 3 .77s.69-2.28 1.08-3.47a2.61 2.61 0 014.7-.57 2.57 2.57 0 012.93 0 20 20 0 002.66 1.66A3.16 3.16 0 0056 29v-1A28 28 0 0035.84 1.06z"
          fill="#dee1d0"
        />
        <path
          d="M42.89 4.52a6.4 6.4 0 011.5 5.1c-.3 2-1.5 4-.59 5.8.8 1.57 2.83 2 4.26 3 1.25.9 2 2.3 3.1 3.42s2.7 2 4.11 1.37a2.91 2.91 0 00.3-.17A28.06 28.06 0 0042.89 4.52z"
          fill="#c8dcbe"
        />
        <path
          d="M.52 23.81a16.35 16.35 0 001.24 5.77 2.88 2.88 0 001.38 1.7c.83.32 2 0 2.5.66a6.05 6.05 0 01.44 1.19c.19.39.78.65 1 .29a1.55 1.55 0 011.37-1.57c-.28.29.26.74.63.6s.61-.53.94-.75c.87-.57 2 .17 2.55 1.07a4.42 4.42 0 01.17 3.93 5.12 5.12 0 01-5.22 2.71A7.3 7.3 0 012.47 36 13 13 0 01.6 30.1a62.82 62.82 0 01-.08-6.29zM44.2 40.13c.18-.88 1.07-.84 1.71-.6a2.67 2.67 0 001.57.32c.82-.21 1.07-1.24 1.66-1.85a5.73 5.73 0 012.44-1.1c.86-.29 2.57-1.39 2.5-2.29-1.32 6.14-7.19 11.74-13.3 13.18a6.27 6.27 0 01-.66-2.48.34.34 0 010-.1 1.35 1.35 0 012-1.06 1.74 1.74 0 001.57 0 2.15 2.15 0 00.73-2.9 1.61 1.61 0 01-.22-1.12z"
          fill="#987671"
        />
        <path
          d="M10.86 25.31a2.69 2.69 0 002.67-1.51 2 2 0 000-2.2 1.82 1.82 0 00-2.29-.24 3.55 3.55 0 00-1.41 2 1.83 1.83 0 00-.09 1.06 1.41 1.41 0 001.12.89zM32.45 6.37A3.28 3.28 0 0029 8.56a1.81 1.81 0 00.82 2.26 2.15 2.15 0 002-.74 9.52 9.52 0 001.34-1.5A1.59 1.59 0 0033.52 7a1.35 1.35 0 00-1.07-.63zM20.22 21.81c-.16-.63-1-.71-1.66-.65l-3 .24a1.43 1.43 0 00.93 1.68 4.14 4.14 0 002.1.06 2.71 2.71 0 001.12-.34 1 1 0 00.51-.99zM42.52 35.94c-.08.36-.26.74-.11 1.07a.81.81 0 001.22.14 2.32 2.32 0 00.62-1.25 2.9 2.9 0 00.13-1.51 1 1 0 00-1.15-.76 1.16 1.16 0 00-.66 1c-.04.45.03.89-.05 1.31zM46.33 27.78a1 1 0 001.34 1 .85.85 0 00-.17-1.17.87.87 0 00-1.17.17zM10.37 30.22a1.13 1.13 0 001.2-.12.88.88 0 10-1.16-1.33 1.09 1.09 0 00-.04 1.45z"
          fill="#dee1d0"
        />
        <path
          d="M6.89 9.67a23.17 23.17 0 11-1.48 1.86 28 28 0 101.48-1.86z"
          fill="#987671"
          opacity={0.33}
        />
        <path
          d="M9.55 49.1A28 28 0 0047.07 7.46 29.18 29.18 0 019.55 49.1z"
          fill="#85625c"
          opacity={0.74}
        />
        <path
          d="M10.25 6.37A28.22 28.22 0 000 28.1a27.92 27.92 0 002.72 12c10.07 2.55 20.37-.8 28-8.91 7.82-8.3 10.71-19.4 7.15-29.39a28 28 0 00-27.62 4.57z"
          fill="#fff"
          opacity={0.15}
        />
        <g mask="url(#planet-pluto_svg__e)">
          <path
            d="M8.86 9.55c7.07-6.79 18.37-8.11 24.29-2s.54 11.57-6.22 20c-5.56 6.9-15.1 12.67-21 6.59S1.79 16.34 8.86 9.55z"
            opacity={0.49}
            fill="url(#planet-pluto_svg__f)"
          />
        </g>
        <path
          d="M20.48 55A28 28 0 1028 0a28.47 28.47 0 00-5.88.62A27.78 27.78 0 0151.58 41a28 28 0 01-31.1 14z"
          style={{
            mixBlendMode: "screen",
          }}
          fill="#fff"
          opacity={0.24}
        />
      </g>
    </svg>
  );
}

export default SvgPlanetPluto;
